<template>
  <div v-html="html"></div>
</template>
<script>
export default {
  name: "NinjaFormsHtml",
  props: { html: { type: String } }
};
</script>
